import {put,takeLatest,call} from 'redux-saga/effects';
import * as searcService from "../../../services/searchService";
import {
    SEARCH_VENUES_WITH_PRODUCTS,
    SEARCH_VENUES_WITH_PRODUCTS_SUCCESS,
    SEARCH_VENUES_WITH_PRODUCTS_ERROR
}
    from "../../actions/searchresults";

function* searchVenuesWithProductsSaga(action) {
    try {
        const data=yield call(searcService.SearchVenuesWithProducts,action.payload)
        yield put({
            type: SEARCH_VENUES_WITH_PRODUCTS_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: SEARCH_VENUES_WITH_PRODUCTS_ERROR,error: error.data ? error.data : error
        });
    }
}


export function* searchVenuesWithProductsSagaWatcher() {
    yield takeLatest(SEARCH_VENUES_WITH_PRODUCTS,searchVenuesWithProductsSaga);
}